import * as React from 'react'
import { SVGProps } from 'react'

const SvgAngleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 478.448 478.448" {...props}>
    <path d="m131.659 0-31.165 32.035 213.31 207.197-213.31 207.141 31.156 32.075 246.304-239.216z" />
  </svg>
)

export default SvgAngleRight
